module.exports = __webpack_public_path__ + "assets/b112.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b112.png
// module id = 584
// module chunks = 0